import config from "@/config";

export const acceptedFiles = [
  "image",
  "video",
  "document",
  ...(config.featureAudioMessageAttachments ? ["audio"] : []),
];
